module.exports = __webpack_public_path__ + "assets/sdlogo.5f4bfa7a.svg";